import { exceptionSubCategoriesApi } from 'app/services/api';
import { normalize, schema } from 'normalizr';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const EXCEPTION_SUB_CATEGORIES_ACTION_TYPE = createNamedActions('exceptionSubCategories', {
  GET_LIST: 'GET_LIST',
  CREATE: 'CREATE',
  EDIT: 'EDIT',
  DELETE: 'DELETE',
});

const exceptionSubCategorySchema = new schema.Entity(
  'data',
  {},
  {
    idAttribute: 'id',
  },
);

export const getExceptionSubCategoriesAction = catchAsyncActionError(
  ({ category } = {}) =>
    async dispatch => {
      const { data } = await exceptionSubCategoriesApi.getExceptionSubCategories({ category });

      return dispatch({
        type: EXCEPTION_SUB_CATEGORIES_ACTION_TYPE.GET_LIST,
        payload: normalize(data || [], [exceptionSubCategorySchema]).entities.data,
      });
    },
);

export const createExceptionSubCategoryAction = catchAsyncActionError(args => async dispatch => {
  const { data } = await exceptionSubCategoriesApi.createExceptionSubCategory(args);
  const normalized = normalize(data, exceptionSubCategorySchema);

  return dispatch({
    type: EXCEPTION_SUB_CATEGORIES_ACTION_TYPE.CREATE,
    payload: normalized.entities.data[normalized.result],
  });
});

export const editExceptionSubCategoryAction = catchAsyncActionError(args => async dispatch => {
  const { data } = await exceptionSubCategoriesApi.editExceptionSubCategory(args);
  const normalized = normalize(data, exceptionSubCategorySchema);

  return dispatch({
    type: EXCEPTION_SUB_CATEGORIES_ACTION_TYPE.EDIT,
    payload: normalized.entities.data[normalized.result],
  });
});

export const deleteExceptionSubCategoryAction = catchAsyncActionError(
  ({ id }) =>
    async dispatch => {
      await exceptionSubCategoriesApi.deleteExceptionSubCategory({ id });

      return dispatch({
        type: EXCEPTION_SUB_CATEGORIES_ACTION_TYPE.DELETE,
        meta: { id },
      });
    },
);
